import { MembershipPlanId } from './../membershipPlanId'
import { PricingGroup } from './pricingGroup'

export const pricingGroupPlans = {
	[PricingGroup.SelfService]: [MembershipPlanId.FREEMIUM, MembershipPlanId.STARTER],
	[PricingGroup.Business]: [MembershipPlanId.BUSINESS, MembershipPlanId.ENTERPRISE],
	[PricingGroup.Network]: [MembershipPlanId.NETWORK],
}

const pricingGroupOrder = [PricingGroup.SelfService, PricingGroup.Business, PricingGroup.Network]

export function findPricingGroupPlan(pricingPlanId: string): PricingGroup | undefined {
	return Object.keys(pricingGroupPlans).find((pricingGroup) =>
		pricingGroupPlans[pricingGroup].includes(pricingPlanId),
	) as PricingGroup
}

export function getFirstMembershipPlanIdInGroup(
	planId: MembershipPlanId,
): MembershipPlanId | undefined {
	for (const groupKey in pricingGroupPlans) {
		const plans = pricingGroupPlans[groupKey]
		if (plans.includes(planId)) {
			return plans[0]
		}
	}
	return undefined // Optionally handle the case where the planId is not found
}

export function getFirstMembershipPlanIdFromAdjacentGroup(
	planId: MembershipPlanId,
	direction: -1 | 1,
): MembershipPlanId | undefined {
	// Find the current group index
	let currentGroupIndex = -1
	for (let i = 0; i < pricingGroupOrder.length; i++) {
		const groupKey = pricingGroupOrder[i]
		const plans = pricingGroupPlans[groupKey]
		if (plans.includes(planId)) {
			currentGroupIndex = i
			break
		}
	}

	if (currentGroupIndex === -1) {
		// planId not found in any group
		return undefined
	}

	const newIndex = currentGroupIndex + direction

	// Check if newIndex is within bounds
	if (newIndex < 0 || newIndex >= pricingGroupOrder.length) {
		return undefined
	}

	const newGroupKey = pricingGroupOrder[newIndex]
	const newGroupPlans = pricingGroupPlans[newGroupKey]

	return newGroupPlans[0]
}
